import { render, staticRenderFns } from "./nameList.vue?vue&type=template&id=522bfa22&scoped=true"
import script from "./nameList.vue?vue&type=script&lang=js"
export * from "./nameList.vue?vue&type=script&lang=js"
import style0 from "./nameList.vue?vue&type=style&index=0&id=522bfa22&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "522bfa22",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Maintenance projects\\devConfig-web-project\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('522bfa22')) {
      api.createRecord('522bfa22', component.options)
    } else {
      api.reload('522bfa22', component.options)
    }
    module.hot.accept("./nameList.vue?vue&type=template&id=522bfa22&scoped=true", function () {
      api.rerender('522bfa22', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/openConfig/nameList.vue"
export default component.exports